<template>
  <div>
  <h1>Error!</h1>
  <p>
    {{message}}
  </p>
  <p>Reference: {{reference}}</p>
  </div>
</template>

<script>
export default {
  name: "ErrorView",
  data() {

    var message = this.$route.query.message;
    if (!message) {
      message = "An unknown error occured";
    }

    
    var ref = this.$route.query.ref;
    if (!message) {
        ref = "?";
    }

    return {
      message: message,
      reference: ref, 
    }
  }
}
</script>